'use client';

import React from 'react';
import Link from 'next/link';
import { 
  SparklesIcon, 
  ChartBarIcon, 
  CubeIcon, 
  LightBulbIcon,
  GlobeAltIcon,
  ServerIcon,
  ChartPieIcon,
  CodeBracketIcon,
  PaintBrushIcon,
  BookmarkIcon
} from '@heroicons/react/24/outline';
import { Category } from '@/data/resources';
import { useTranslation } from '@/hooks/useTranslation';

// Map of icon strings to actual icon components
const iconMap: Record<string, React.ReactNode> = {
  SparklesIcon: <SparklesIcon className="w-5 h-5" />,
  ChartBarIcon: <ChartBarIcon className="w-5 h-5" />,
  CubeIcon: <CubeIcon className="w-5 h-5" />,
  LightBulbIcon: <LightBulbIcon className="w-5 h-5" />,
  GlobeAltIcon: <GlobeAltIcon className="w-5 h-5" />,
  ServerIcon: <ServerIcon className="w-5 h-5" />,
  ChartPieIcon: <ChartPieIcon className="w-5 h-5" />,
  CodeBracketIcon: <CodeBracketIcon className="w-5 h-5" />,
  PaintBrushIcon: <PaintBrushIcon className="w-5 h-5" />,
  BookmarkIcon: <BookmarkIcon className="w-5 h-5" />
};

interface SidebarProps {
  categories: Category[];
}

const Sidebar = ({ categories }: SidebarProps) => {
  const { t } = useTranslation();
  
  return (
    <aside className="fixed left-0 top-0 bottom-0 w-64 bg-gray-900 text-white overflow-y-auto py-6 border-r border-gray-800 hidden lg:block">
      <div className="px-6">
        <Link 
          href="/" 
          className="flex items-center space-x-2 mb-10"
        >
          <span className="text-2xl font-bold">{t('siteTitle')}</span>
        </Link>
      </div>

      <nav className="mt-6">
        <ul className="space-y-2 px-4">
          {categories.map((category) => (
            category.resources.length > 0 && (
              <li key={category.id}>
                <Link 
                  href={`#${category.id}`} 
                  className="flex items-center p-2 rounded hover:bg-gray-800 transition-colors duration-200"
                >
                  <span className="mr-3 text-gray-400">
                    {iconMap[category.icon] || iconMap['BookmarkIcon']}
                  </span>
                  <span>{t(category.id) !== category.id ? t(category.id) : category.name}</span>
                </Link>
              </li>
            )
          ))}
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar; 